import { Centrifuge } from 'centrifuge';

const centrifugoUrl = process.env.VUE_APP_CENTRIFUGO_WS_URL || 'ws://localhost:8001/connection/websocket';
const appServer = process.env.VUE_APP_SERVER || '';

let centrifugeClient = null;

export const getCentrifugoClient = async () => {
    if (centrifugeClient) return centrifugeClient;

    centrifugeClient = new Centrifuge(centrifugoUrl);
    centrifugeClient.connect();

    return centrifugeClient;
};

export const disconnectCentrifugo = () => {
    if (centrifugeClient) {
        centrifugeClient.disconnect();
        centrifugeClient = null;
    }
};

export const isRuServer = () => appServer === 'ru';